/**
 * @generated SignedSource<<38a6ada76c0ed74e92b6ba71deb2722a>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
export type useFinancialServiceUpdateTriggerQuery$variables = {
  projectId: string;
};
export type useFinancialServiceUpdateTriggerQuery$data = {
  readonly viewer: {
    readonly actualPersonId: string | null;
    readonly component: string | null;
    readonly project: {
      readonly id: string;
      readonly financialCalculationTrigger: {
        readonly timestamp: number | null;
        readonly duration: number | null;
      } | null;
    } | null;
  } | null;
};
export type useFinancialServiceUpdateTriggerQuery = {
  variables: useFinancialServiceUpdateTriggerQuery$variables;
  response: useFinancialServiceUpdateTriggerQuery$data;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "projectId"
  }
],
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "actualPersonId",
  "storageKey": null
},
v2 = {
  "alias": null,
  "args": [
    {
      "kind": "Literal",
      "name": "name",
      "value": "financial_calculation_trigger"
    }
  ],
  "kind": "ScalarField",
  "name": "component",
  "storageKey": "component(name:\"financial_calculation_trigger\")"
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": [
    {
      "kind": "Variable",
      "name": "internalId",
      "variableName": "projectId"
    }
  ],
  "concreteType": "ProjectType",
  "kind": "LinkedField",
  "name": "project",
  "plural": false,
  "selections": [
    (v3/*: any*/),
    {
      "alias": null,
      "args": [
        {
          "kind": "Literal",
          "name": "allowLongerRuntime",
          "value": true
        }
      ],
      "concreteType": "FinancialCalculationTrigger",
      "kind": "LinkedField",
      "name": "financialCalculationTrigger",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "timestamp",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "duration",
          "storageKey": null
        }
      ],
      "storageKey": "financialCalculationTrigger(allowLongerRuntime:true)"
    }
  ],
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "useFinancialServiceUpdateTriggerQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Viewer",
        "kind": "LinkedField",
        "name": "viewer",
        "plural": false,
        "selections": [
          (v1/*: any*/),
          (v2/*: any*/),
          (v4/*: any*/)
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "useFinancialServiceUpdateTriggerQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Viewer",
        "kind": "LinkedField",
        "name": "viewer",
        "plural": false,
        "selections": [
          (v1/*: any*/),
          (v2/*: any*/),
          (v4/*: any*/),
          (v3/*: any*/)
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "da037b72696c7dd625a89faf89b493b9",
    "id": null,
    "metadata": {},
    "name": "useFinancialServiceUpdateTriggerQuery",
    "operationKind": "query",
    "text": "query useFinancialServiceUpdateTriggerQuery(\n  $projectId: ID!\n) {\n  viewer {\n    actualPersonId\n    component(name: \"financial_calculation_trigger\")\n    project(internalId: $projectId) {\n      id\n      financialCalculationTrigger(allowLongerRuntime: true) {\n        timestamp\n        duration\n      }\n    }\n    id\n  }\n}\n"
  }
};
})();

(node as any).hash = "49eeb4998a84590649c08a7dbd78e6a9";

export default node;
